import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {useNavigate} from 'react-router-dom';
import LoadingInside from "../../components/Loading/LoadingInside";
import CardCarousel from "../Top/TopRecommendedTours/CardCarousel";
import {format} from 'date-fns';
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import s from "./CartPage.module.scss";
import titleImage from "../../assets/images/titleImage.png";

const REZDY_BASE_URL = process.env.REACT_APP_API_LOCAL_URL;

const CartPage = () => {
    const navigate = useNavigate();

    const [cartItems, setCartItems] = useState([]);
    const [quote, setQuote] = useState(null);
    const [couponCode, setCouponCode] = useState('');
    const [appliedCoupon, setAppliedCoupon] = useState(null);
    const [couponLoading, setCouponLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [quoteLoading, setQuoteLoading] = useState(false);
    const [error, setError] = useState('');
    const [showRecommendation, setShowRecommendation] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "auto",
        });
    }, []);

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem('booking_cart') || '[]');
        setCartItems(stored);
        setLoading(false);
    }, []);

    useEffect(() => {
        if (!cartItems.length) {
            setQuote(null);
            return;
        }
        fetchQuote();
    }, [cartItems, appliedCoupon]);

    const fetchQuote = async () => {
        setQuoteLoading(true);
        setError('');

        try {
            const payload = {
                coupon: appliedCoupon || undefined,
                items: cartItems.map(item => ({
                    productCode: item.productCode,
                    startTimeLocal: item.startTimeLocal,
                    quantities: item.quantities,
                    extras: item.extras || []
                }))
            };

            const res = await axios.post(
                `${REZDY_BASE_URL}booking/quote`,
                payload
            );

            setQuote(res.data.data?.booking || null);
        } catch (err) {

            setError(err?.response?.data?.message ?? '料金の取得に失敗しました。');
        } finally {
            setQuoteLoading(false);
        }
    };
    const applyCoupon = async () => {

        if (!couponCode.trim()) return;

        setCouponLoading(true);
        setError('');

        try {

            const payload = {
                coupon: couponCode,
                items: cartItems.map(item => ({
                    productCode: item.productCode,
                    startTimeLocal: item.startTimeLocal,
                    quantities: item.quantities,
                    extras: item.extras || []
                }))
            };

            await axios.post(
                `${REZDY_BASE_URL}booking/quote`,
                payload
            );

            setAppliedCoupon(couponCode);

        } catch (err) {
            setAppliedCoupon(null);
            setCouponCode("");
            if (err?.response?.data?.error === 'INVALID_C') {

                setAppliedCoupon(null);
                setError('無効なクーポンコードです');

            } else {

                setError(
                    err?.response?.data?.message ??
                    'クーポンの適用に失敗しました'
                );

            }

        } finally {

            setCouponLoading(false);

        }
    };
    const removeItem = (index) => {
        const updated = cartItems.filter((_, i) => i !== index);
        setCartItems(updated);
        localStorage.setItem('booking_cart', JSON.stringify(updated));
        window.dispatchEvent(
            new Event('cartUpdated')
        );
    };

    const clearCart = () => {
        localStorage.removeItem('booking_cart');
        setCartItems([]);
        setQuote(null);
        window.dispatchEvent(
            new Event('cartUpdated')
        );
    };

    const handleCheckout = () => {
        const fields = buildUniqueFields();

        navigate('/checkout-form', {
            state: {
                cartItems,
                quote,
                bookingFields: fields.bookingFields,
                participantFields: fields.participantFields,
                totalParticipants,
                couponCode: appliedCoupon
            }
        });
    };
    const buildUniqueFields = () => {
        const bookingMap = new Map();
        const participantMap = new Map();

        cartItems.forEach(item => {
            (item.fields || []).forEach(field => {

                if (field.visiblePerBooking || field.requiredPerBooking) {
                    bookingMap.set(field.label, field);
                }

                if (field.visiblePerParticipant || field.requiredPerParticipant) {
                    participantMap.set(field.label, field);
                }
            });
        });

        return {
            bookingFields: [...bookingMap.values()],
            participantFields: [...participantMap.values()]
        };
    };

    const totalParticipants = cartItems.reduce(
        (sum, item) => sum + (item.participantsCount || 0),
        0
    );
    const formatPrice = (price) =>
        new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'AUD'
        }).format(price || 0);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="spinner-border text-primary"/>
            </div>
        );
    }

    const recommendedTours =
        quote?.items?.length > 0
            ? Array(5).fill({
                productName: quote.items[0].productName,
                productCode: quote.items[0].productCode,
                image: quote.items[0].image || '/placeholder.jpg',
                priceFrom: quote.items[0].subtotal
            })
            : [];

    if (!cartItems.length) {
        return (

            <div className="container py-5 text-center">
                <h3>カート</h3>
                <div className="alert alert-info mt-3">
                    カートは空です
                </div>

                <button
                    className="btn btn-primary mt-3"
                    onClick={() => navigate('/all-tours')}
                >
                    ツアーを見る
                </button>
            </div>


        );
    }
    if (quoteLoading)

        return (<LoadingInside height={"80vh"}/>)
    const breadcrumbItems = [
        {name: "ホーム", link: "/"},
        {name: "カート", link: "/cart"},

    ];
    return (
        <div className="container py-4">
            {/* HEADER */}
            <div className="row mt-3 mb-4">
                <div className="col-12">
                    <Breadcrumb items={breadcrumbItems}/>
                    <div className={s.titleContainer}>
                        <h2>
                            <img className={s.titleImage} src={titleImage}/>
                            カート
                        </h2>
                        <p className="text-muted mt-2">
                            ご予約内容をご確認ください
                        </p>
                    </div>
                </div>
            </div>

            {error && (
                <div className="alert alert-danger">
                    {error}
                </div>
            )}

            <div className="row g-4">

                {/* LEFT SIDE */}
                <div className="col-lg-8">

                    {quote?.items?.map((item, index) => (
                        <div
                            key={index}
                            className={`${s.cartCard} mb-4`}
                        >
                            {/* TOP */}
                            <div className={s.cartTop}>

                                {/* IMAGE */}
                                {/*<div className={s.imageWrap}>*/}
                                {/*    <img*/}
                                {/*        src={*/}
                                {/*            item.image ||*/}
                                {/*            "/placeholder.jpg"*/}
                                {/*        }*/}
                                {/*        alt={item.productName}*/}
                                {/*    />*/}
                                {/*</div>*/}

                                {/* INFO */}
                                <div className={s.cartInfo}>
                                    <h4>{item.productName}</h4>

                                    <p className={s.date}>
                                        {format(
                                            new Date(
                                                item.startTimeLocal
                                            ),
                                            'yyyy年M月d日'
                                        )}
                                    </p>
                                </div>

                                <button
                                    className={s.removeBtn}
                                    onClick={() =>
                                        removeItem(index)
                                    }
                                >
                                    ✕
                                </button>
                            </div>

                            {/* BODY */}
                            <div className={s.cartBody}>

                                {/* quantities */}
                                {item.quantities?.map(
                                    (q, i) => (
                                        <div
                                            key={i}
                                            className={
                                                s.lineItem
                                            }
                                        >
                                        <span>
                                            {
                                                q.optionLabel
                                            }{" "}
                                            ×{" "}
                                            {
                                                q.value
                                            }
                                        </span>

                                            <strong>
                                                {formatPrice(
                                                    q.optionPrice *
                                                    q.value
                                                )}
                                            </strong>
                                        </div>
                                    )
                                )}

                                {/* extras */}
                                {item.extras?.length >
                                    0 && (
                                        <>
                                            <div
                                                className={
                                                    s.divider
                                                }
                                            />

                                            <h6>
                                                追加オプション
                                            </h6>

                                            {item.extras.map(
                                                (
                                                    ex,
                                                    i
                                                ) => (
                                                    <div
                                                        key={
                                                            i
                                                        }
                                                        className={
                                                            s.lineItem
                                                        }
                                                    >
                                                <span>
                                                    {
                                                        ex.name
                                                    }{" "}
                                                    ×{" "}
                                                    {
                                                        ex.quantity
                                                    }
                                                </span>

                                                        <strong>
                                                            {formatPrice(
                                                                ex.price *
                                                                ex.quantity
                                                            )}
                                                        </strong>
                                                    </div>
                                                )
                                            )}
                                        </>
                                    )}

                                <div
                                    className={
                                        s.divider
                                    }
                                />

                                <div
                                    className={
                                        s.totalLine
                                    }
                                >
                                <span>
                                    小計
                                </span>
                                    <strong>
                                        {formatPrice(
                                            item.subtotal
                                        )}
                                    </strong>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span>税金</span>
                                    <strong>({formatPrice(item.totalItemTax)})</strong>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* RIGHT SIDE */}
                <div className="col-lg-4">
                    <hr/>
                    <button
                        className={s.continueShoppingBtn}
                        onClick={() => navigate("/all-tours")}
                    >
                        ← ツアーを探す
                    </button>
                    <hr/>
                    <div className={s.summaryCardModern}>
                        <h4>料金内訳</h4>
                        <div className={s.couponBox}>

                            <label className={s.couponLabel}>
                                クーポン
                            </label>

                            <div className={s.couponRow}>

                                <input
                                    type="text"
                                    placeholder="クーポンコード"
                                    value={couponCode}
                                    onChange={(e) => setCouponCode(e.target.value)}
                                    className={s.couponInput}
                                />

                                <button
                                    className={s.applyBtn}
                                    onClick={applyCoupon}
                                    disabled={couponLoading}
                                >
                                    適用
                                </button>

                            </div>

                            {appliedCoupon && (
                                <div className={s.appliedCoupon}>
                                    クーポンが適用されました: {appliedCoupon}
                                </div>
                            )}

                            {quote?.totalDiscount > 0 && (
                                <div className={s.discountLine}>
                                    割引: -{formatPrice(quote.totalDiscount)}
                                </div>
                            )}

                        </div>
                        <div className={s.summaryLine}>
                            <span>合計</span>
                            <strong>
                                {formatPrice(
                                    quote?.totalAmount
                                )}
                            </strong>
                        </div>

                        <div className={s.summaryLine}>
                            <span>割引</span>
                            <strong>
                                {formatPrice(
                                    quote?.totalPaid
                                )}
                            </strong>
                        </div>

                        <div className={s.summaryDivider}/>

                        <div
                            className={
                                s.summaryGrand
                            }
                        >
                            <span>お支払い合計</span>
                            <strong>
                                {formatPrice(
                                    quote?.totalDue
                                )}
                            </strong>
                        </div>

                        <button
                            className={s.checkoutBtn}
                            disabled={
                                quoteLoading ||
                                !quote
                            }
                            onClick={
                                handleCheckout
                            }
                        >
                            チェックアウト →
                        </button>

                        <button
                            className={
                                s.clearBtn
                            }
                            onClick={
                                clearCart
                            }
                        >
                            カートを空にする
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartPage;